/**
 * Action Ticker
 * This betting round's actions on a one-line ticker tape (see Ticker):
 * newest at the right end, crawling when they don't all fit.
 */

import React from 'react';
import type { ActionHistoryItem } from '../../store/types';
import { formatChips } from '../../utils/format';
import Ticker from './Ticker';

const ACTION_WORD: Record<string, string> = {
  FOLD: 'folds',
  CHECK: 'checks',
  CALL: 'calls',
  BET: 'bets',
  RAISE: 'raises',
  ALL_IN: 'goes all-in',
};

const Item: React.FC<{ action: ActionHistoryItem }> = ({ action }) => (
  <span className="pl-2 pr-4 shrink-0">
    <span className="font-semibold text-white">{action.username}</span>
    <span className={action.isOptimistic ? 'text-gray-500 italic' : 'text-gray-300'}>
      {' '}
      {ACTION_WORD[action.action] ?? action.action.toLowerCase()}
    </span>
    {action.amount !== undefined && action.amount > 0 && (
      <span className="text-yellow-400"> {formatChips(action.amount)}</span>
    )}
  </span>
);

/** `since`: when this betting round began — only its actions ride the tape. */
const ActionTicker: React.FC<{ actions: ActionHistoryItem[]; since: number }> = ({ actions, since }) => (
  <Ticker
    testId="action-ticker"
    heightClass="h-[24px] shrink-0 text-[11px] leading-none"
    items={actions.filter((a) => a.timestamp >= since).map((a) => ({ key: a.id, node: <Item action={a} /> }))}
    empty={<span className="px-2 text-gray-600 italic">No actions yet</span>}
  />
);

export default ActionTicker;
